import { shuffle } from 'lodash';
import { states } from '../data/states.json';
import { CHECK_SELECTION, CHOOSE_Q_TYPE, FINISHED, REFRESH } from '../actions/types';
import { CheckSelection } from './helpers/checks';

const shuffledStates = shuffle(states).map(c => ({ ...c, misses: 0, fill: '#D3D3D3', correct: 0, incorrect: false }));

const INITIAL_STATE = {
  current: shuffledStates[0],
  finished: false,
  states: shuffledStates,
  incorrect: 0,
  correct: 0,
  qtype: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CHOOSE_Q_TYPE: {
      return { ...state, qtype: action.id };
    }

    case CHECK_SELECTION: return CheckSelection(state, action);

    case FINISHED: {
      const finishedState = { ...CheckSelection(state, action), finished: true };
      return { state: finishedState };
    }

    case REFRESH: {
      const newShuffledStates = shuffle(shuffledStates);
      return {
        ...state,
        current: newShuffledStates[0],
        states: newShuffledStates,
        incorrect: 0,
        correct: 0,
        finished: false,
        qtype: action.id,
      };
    }

    default: return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/StateNames.js